import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';

import { WIZ_EVENT_TYPE} from '@wizeoo/akm-core-lib';
import { WizBaseCollector, WizCheckbox, WizVgroup, WizEventManager, WizEvent, WizTranslationManager } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationItemObj, Measure } from '@wizeoo/akm-message-lib';
import { BaselineEngine, FeiKeyDef, WizConstants, EM_ACTION, KEY_KIND } from '@wizeoo/akm-compute-lib';

import { WIDGET_KIND } from '../../../../model/enums';
import { AlkEvent } from '../../../../framework/events/alk.event';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { PivotBasePop } from '../../pivot/renderers/settings/pivot-base.pop';
import { PivotEditItemRenderer } from '../../pivot/renderers/settings/pivot-edit-item.renderer';
import { gridsterItemEvent } from '../../form/generic/form-widget.gridster.component';
import { ViewData } from '../../../../model/view.data';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';


@Component({
  // popUp d'édition des forms : gestion des champs affichés
  selector: 'tile-settings-pop',
  templateUrl: './tile-settings.pop.html',
})
export class TileSettingsPop extends PivotBasePop {

  constructor(public elementRef: ElementRef, private _cdRef: ChangeDetectorRef) {
    super(elementRef);
  }

  @ViewChild('gpNextStep', { read: WizVgroup }) gpNextStep: WizVgroup; // liste des mesures sur le nextStep
  @ViewChild('cbShowNextStep', { read: WizCheckbox }) cbShowNextStep: WizCheckbox; // cb d'affichage de la colonne delete
  
  // dimensions demandées
  public static width: string = '900px';
  public static height: string = 'calc(100% - 81px)';

  
  public popUpMode: WIDGET_KIND = WIDGET_KIND.TILE; // le mode de cette pop, pour alimenter les PKD
  public renderer: any = PivotEditItemRenderer;
  public widgets: GridsterWidgetItem[];

  /** mise en place des écouteurs */
  public addListeners(): void {
    super.addListeners();
    WizEventManager.addListener(this, this.cbShowNextStep, WIZ_EVENT_TYPE.CHANGE, this.showHideNextStep); // ecouteur sur le filtre de la DS principale
  }

  /** interception check affichage next step */
  private showHideNextStep(e:WizEvent = null): void {
    this.gpNextStep.visible = this.cbShowNextStep.wizChecked;
  }

  /**
   * accesseur sur le 1er élément du tile, pour rendu plus joli...
   */
  public get entity(): any {
    if(this.widget?.mainDS?.getWorkedSource()?.length > 0) {
      return this.widget?.mainDS?.getWorkedSource()[0];
    }
    return null;
  }


  /**
   * @override
   * sur séquence de démarrage, alimentation des listes avec leurs DS
   */
  public feedDatasources(): void {
    super.feedDatasources();

    // ajout du fake pour mettre un libellé
    this.dataSource.addItem(this.buildFake(ViewData.FORM_HTML,'$.common.free.content.$', -3 ));
    this.dataSource.addItem(this.buildFake(ViewData.FORM_IMAGE,'$.common.free.image.$', -2 ));
    this.dataSource.addItem(this.buildFake(ViewData.FORM_ACTION,'$.common.free.action.$', -1 ));

    this.cbShowNextStep.wizChecked = !!this.context.nxstep;
    this.showHideNextStep();

    this.widgets = this.context.ff?.map((wcio: WidgetConfigurationItemObj) => {
      const result: GridsterWidgetItem = new GridsterWidgetItem(wcio, new FormFieldObj(this.widget, this.fei, wcio));
      return result;
    }) || [];

  }


  /** icone de suppression globale */
  public onDeleteClick(): void {
    this.widgets = [];
  }

  onWidgetsChanged(event: gridsterItemEvent) {
    // console.log('onWidgetsChanged',event, this.widgets);
    switch(event.action) {
      case EM_ACTION.CREATE:
        this.widgets = [event.item, ...this.widgets];
        break;
      case EM_ACTION.UPDATE:
        // console.log('onWidgetsChanged rien a faire');
        event.item.updateCoords(); // mise à jour des coords
        break;
      case EM_ACTION.DELETE:
        this.widgets.splice(this.widgets.indexOf(event.item), 1);
        break;     
    }
  }

  public updateContext(): void {
    super.updateContext();
    this.context.ff = this.widgets.map(w => w.source);
    this.context.nxstep = this.cbShowNextStep.wizChecked;
  }

  /**
   * override pour passage du resize sur les champs posés en sublist
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
   protected showConfPop(e: AlkEvent): void {
    
    const baseCollector: WizBaseCollector = e.data[1];
    const pivotField: PivotField = e.data[0];
    if (!!baseCollector && baseCollector.id === 'lstData') {
      pivotField.colRezisable = true;
    }
    super.showConfPop(e);
  }

  /**
   * construction des fakes pour gérer libellé, titre et comment
   * @param code 
   * @param label 
   * @param order 
   * @returns 
   */
  private buildFake(code: string, label: string, order: number): PivotField {
    // construction d'un fake de mesure pour alimenter le pivotField
    let fakeMeas: Measure = new Measure();
    fakeMeas.code = code;
    fakeMeas.shortCode = code;
    fakeMeas.mode = WizConstants.MEASURE_MODE_INTERACT;
    
    
    let fake: FeiKeyDef = BaselineEngine.buildFeiKeyDef(this.fei, KEY_KIND.MEASURE, fakeMeas);
    fake.label =  WizTranslationManager.getInstance().translateKey(label);
    fake.sortKey = 9; // après les filters
    fake.order = order;

    let fakePivot: PivotField = new PivotField(this.widget, null, fake, null);

    return fakePivot;
  }

}
